import { io } from 'socket.io-client';
import { BASE_URL } from './config/env';

let socket = null;

export const connectSocket = (token) => {
  if (!socket) {
    socket = io(BASE_URL, {
      transports: ['websocket'], // faster
      withCredentials: true,
      auth: { token },
    });
  } else {
    socket.auth = { token };
    socket.connect();
  }
  return socket;
};

export const getSocket = () => socket;
